module.exports = __webpack_public_path__ + "img/pose-m-34.42f5ffdb.png";